export default __webpack_public_path__ + "fe10cbad202d0ba8e978d8274ac92ee6.png";